import Close from '@mui/icons-material/Close';
import ArrowBack from '@mui/icons-material/ArrowBack';
import {
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { ReactNode } from 'react';
import { useLocalization } from '@/hooks/useLocalization';

interface AccountModalProps {
  dialogContent: ReactNode;
  onClose: () => void;
  onHeaderBack?: () => void;
  open: boolean;
  title: string;
}

const AccountModal = ({
  dialogContent,
  onClose,
  onHeaderBack,
  open,
  title,
}: AccountModalProps) => {
  const { t } = useLocalization();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='md'
      sx={(theme) => ({
        [theme.breakpoints.down(1001)]: {
          '& .MuiDialog-container': {
            alignItems: 'stretch',
            height: '100dvh',
            maxHeight: '100dvh',
          },
          '& .MuiDialog-paper': {
            height: '100dvh !important',
            width: '100% !important',
            position: 'relative !important',
            top: '0 !important',
            left: '0 !important',
            margin: '0px !important',
            borderRadius: 0,
            display: 'flex !important',
            flexDirection: 'column',
            maxHeight: '100dvh !important',
            overflow: 'hidden',
            paddingBottom:
              'var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))',
          },
          '& .MuiDialogTitle-root': {
            flexShrink: 0,
            paddingTop:
              'calc(16px + var(--safe-area-inset-top, env(safe-area-inset-top, 0px)))',
          },
          '& .MuiDialogContent-root': {
            flex: '1 1 auto',
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
          },
        },
      })}
    >
      <DialogTitle borderBottom='1px solid var(--divider, rgba(0, 0, 0, 0.12))'>
        <Stack
          direction='row'
          justifyContent='space-between'
        >
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
            }}
          >
            {onHeaderBack && (
              <IconButton
                aria-label={t('back')}
                onClick={onHeaderBack}
              >
                <ArrowBack />
              </IconButton>
            )}

            <Typography variant='h6'>{title}</Typography>
          </Box>

          <Box>
            <IconButton
              aria-label={t('close')}
              onClick={onClose}
            >
              <Close />
            </IconButton>
          </Box>
        </Stack>
      </DialogTitle>

      {/* Individual pages handle content & footers */}
      {dialogContent}
    </Dialog>
  );
};

export default AccountModal;
